import { useState, type FormEvent } from "react";
import { client } from "../../lib/api.ts";

type Status = "idle" | "loading" | "success" | "error";

/** Email capture (single opt-in), styled to match the paper desk. */
export function SubscribeForm() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<Status>("idle");
  const [message, setMessage] = useState("");

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (status === "loading") return;
    setStatus("loading");
    try {
      const res = await client.subscribers.subscribe(email.trim());
      setStatus("success");
      setMessage(res.message);
      setEmail("");
    } catch (err) {
      setStatus("error");
      setMessage(
        err instanceof Error
          ? err.message
          : "Something went wrong — please try again.",
      );
    }
  }

  return (
    <section className="subscribe-card" aria-label="Subscribe to the ritual">
      <span className="subscribe-tape" aria-hidden="true" />
      <p className="subscribe-eyebrow">the weekly ritual, in your inbox</p>
      <p className="subscribe-sub">
        One short note a week, straight to your inbox. No spam, unsubscribe
        anytime.
      </p>

      {status === "success" ? (
        <p className="subscribe-msg is-success" role="status">
          {message}
        </p>
      ) : (
        <form className="subscribe-form" onSubmit={onSubmit} noValidate>
          <input
            type="email"
            className="subscribe-input"
            placeholder="you@example.com"
            value={email}
            required
            autoComplete="email"
            aria-label="Email address"
            onChange={(e) => {
              setEmail(e.target.value);
              if (status === "error") setStatus("idle");
            }}
            disabled={status === "loading"}
          />
          <button
            type="submit"
            className="subscribe-btn"
            disabled={status === "loading" || email.trim() === ""}
          >
            {status === "loading" ? "adding you…" : "subscribe"}
          </button>
        </form>
      )}

      {status === "error" && (
        <p className="subscribe-msg is-error" role="alert">
          {message}
        </p>
      )}
    </section>
  );
}
